/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A member of an organization as shown in a member picker (no contact data).
 * @export
 * @interface OrganizationMemberRead
 */
export interface OrganizationMemberRead {
    /**
     * 
     * @type {string}
     * @memberof OrganizationMemberRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMemberRead
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMemberRead
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMemberRead
     */
    last_name?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrganizationMemberRead
     */
    role_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof OrganizationMemberRead
     */
    grade?: number | null;
}

/**
 * Check if a given object implements the OrganizationMemberRead interface.
 */
export function instanceOfOrganizationMemberRead(value: object): value is OrganizationMemberRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function OrganizationMemberReadFromJSON(json: any): OrganizationMemberRead {
    return OrganizationMemberReadFromJSONTyped(json, false);
}

export function OrganizationMemberReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMemberRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'role_ids': json['role_ids'] == null ? undefined : json['role_ids'],
        'grade': json['grade'] == null ? undefined : json['grade'],
    };
}

export function OrganizationMemberReadToJSON(json: any): OrganizationMemberRead {
    return OrganizationMemberReadToJSONTyped(json, false);
}

export function OrganizationMemberReadToJSONTyped(value?: OrganizationMemberRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'username': value['username'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'role_ids': value['role_ids'],
        'grade': value['grade'],
    };
}

